<style src="./ModalUsers.scss" lang="scss"></style>
<template>
  <div class="user-assigned">
    <ul class="list">
      <li
        class="item"
        v-for="(user, userIdx) in value"
        :key="userIdx"
        :title="user.text">
        <span class="username">{{ user.text | abbrevUser }}</span>

        <div
          v-if="userId.toString() === user.id.toString()"
          class="remove"
          @click="removeUser(userIdx)">
          <icon-close class="closeicon" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { IconUser, IconClose } from '@/components/primitives/icons'
import { mapGetters } from 'vuex'

export default {
  name: 'ModalUsers',
  components: {
    IconUser, IconClose
  },
  props: {
    value: {
      default: null
    }
  },
  computed: {
    ...mapGetters({
      userId: 'Login/GET_USER_ID'
    })
  },
  filters: {
    abbrevUser (name) {
      if (!name) return '@'
      const splittedName = name.split(' ')
      if (splittedName.length < 2) {
        const userIdentification = name.substr(0, 1) + name.substr(1, 1)
        return userIdentification.toUpperCase()
      } else {
        const userIdentification = splittedName[0].substr(0, 1) + splittedName[1].substr(0, 1)
        return userIdentification.toUpperCase()
      }
    }
  },
  methods: {
    removeUser (userIdx) {
      this.$emit('remove', this.value[userIdx])
      const list = [...this.value]
      list.splice(userIdx, 1)
      this.$emit('input', list)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/board/components/modal-users/ModalUsers.vue